import React, { useEffect, useState } from 'react';
import "../css/form.css";
import styles from "page/css/Exhibition.module.css";

import { Chip, FormControl, Switch, TextField } from "@mui/material";
import defaultImage from "asset/images/images.png";
import Button from "../inputs/Button";
import Box from "../inputs/Box";
import ExhibitionFormHeader from "./ExhibitionFormHeader";
import ExhibitionFormCommentator from "./ExhibitionFormCommentator";
import ExhibitionFormSubTopic from "./ExhibitionFormSubTopic";

import ExhibitionService from "service/apiConfig/ExhibitionService";
import { alertValidation } from "service/util/alertValidation";
import { imageMimeType } from "../../config";

import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { exhibitionActions } from "reducers/exhibition";
import checkByteSize from "../../service/util/checkByteSize";
import Swal from "sweetalert2";
import {audioActions} from "../../reducers/audio";

const ExhibitionForm = ({ create, edit }) => {
    const params = useParams();
    const dispatch = useDispatch();
    const type = useSelector(state => state.exhibitionData.type);
    const exhibitionRoom = useSelector(state => state.exhibitionData.exhibitionRoom);
    const previewImage = useSelector(state => state.exhibitionData.previewImage);

    const [fileDataUrl, setFileDataUrl] = useState(null);
    useEffect(() => {
        ExhibitionService.getCommentatorByType(1)
            .then(response => {
                if (response.data.data.length >= 1) {
                    dispatch(exhibitionActions.setCommentatorList(response.data.data));
                }
            })
            .catch(err => console.log(err));
    }, [dispatch])
    useEffect(() => {
        if (edit) {
            ExhibitionService.getById(params.id)
                .then(response => {
                    dispatch(exhibitionActions.setExhibitionRoom(response.data.data.exhibitionRoom));
                    dispatch(exhibitionActions.setSubTopicList(response.data.data.roomSubTopicList));
                })
                .catch(err => console.log(err));
        }
    }, [dispatch, params.id, edit])

    useEffect(() => {
        let fileReader, isCancel = false;
        if (previewImage !== null) {
            fileReader = new FileReader();
            fileReader.onload = (e) => {
                const { result } = e.target;
                if (result && !isCancel) {
                    setFileDataUrl(result);
                }
            };
            fileReader.readAsDataURL(previewImage? previewImage : null);
        }
        return () => {
            isCancel = true;
            if (fileReader && fileReader.readyState === 1) {
                fileReader.abort();
            }
        }
    }, [previewImage]);

    const onChangeInput = (e) => {
        const { name, value } = e.target;
        dispatch(exhibitionActions.setExhibitionRoom({
            ...exhibitionRoom,
            [name]: value,
        }))
    }

    const onChangeSwitch = (e) => {
        dispatch(exhibitionActions.setExhibitionRoom({
            ...exhibitionRoom,
            invalid: !e.target.checked,
        }));
    }
    const onChangeImageFileHandler = (e) => {
        e.preventDefault();
        const imageFile = e.target.files[0];
        if (!imageFile.type.match(imageMimeType)) {
            alertValidation("해당 형식의 파일은 지원하지 않습니다.\nJPG, PNG 파일을 등록해 주세요.");
            return false;
        } else if (checkByteSize(imageFile.size)) {
            Swal.fire({
                text: `이미지 용량은 5MB 이내로 등록 가능합니다.`,
                icon: 'warning',
                confirmButtonText: '확인',
            }).then(r => { if (r.isConfirmed) {
                return false;
            }});
        } else {
            dispatch(exhibitionActions.setExhibitionRoom({ ...exhibitionRoom, imageUrl: null }));
            dispatch(exhibitionActions.setFile(imageFile));
            dispatch(exhibitionActions.setPreviewImage(imageFile));
        }
    }

    return (
        <form className={styles.exhForm}>
            <ExhibitionFormHeader create={create} edit={edit} />
            <Box className={styles.exhContainer}>
                <h3>전시 정보</h3>
                <Box className={styles.exhBox}>
                    <div>
                        <Chip label="전시관 이름" sx={{ marginBottom: "0.8rem", lineHeight: "32px" }} />
                        <label className={styles.exhLabel}>
                            <TextField
                                className={styles.textInput}
                                value={exhibitionRoom.roomNo || ''}
                                onChange={onChangeInput}
                                name={"roomNo"}
                                placeholder={"전시관 이름을 입력해주세요."}
                                variant="outlined"
                                size="small"
                                required={true}
                            />
                        </label>
                        <Chip label="콘텐츠 이름" sx={{ marginBottom: "0.8rem", lineHeight: "32px" }} />
                        <label className={styles.exhLabel}>
                            <TextField
                                className={styles.textInput}
                                value={exhibitionRoom.name || ''}
                                onChange={onChangeInput}
                                name={"name"}
                                placeholder={"콘텐츠 이름을 입력해주세요."}
                                variant="outlined"
                                size="small"
                                required={true}
                            />
                        </label>
                        <Chip label="콘텐츠 소개" sx={{ marginBottom: "0.8rem", lineHeight: "32px" }} />
                        <label className={styles.exhLabel} style={{ marginBottom: "1rem" }}>
                            <TextField
                                className={styles.textInput}
                                value={exhibitionRoom.introduction || ''}
                                onChange={onChangeInput}
                                name={"introduction"}
                                placeholder={"콘텐츠 소개를 입력해주세요."}
                                variant="outlined"
                                size="small"
                                required={true}
                                multiline
                                rows={4}
                            />
                        </label>
                        <Chip label="이미지 대체문구" sx={{ marginBottom: "0.8rem", lineHeight: "32px" }} />
                        <label className={styles.exhLabel}>
                            <label className={styles.exhLabel}>
                                <TextField
                                    className={styles.textInput}
                                    value={exhibitionRoom.imageAltText || ''}
                                    onChange={onChangeInput}
                                    name={"imageAltText"}
                                    placeholder={"이미지 대체문구를 입력해주세요."}
                                    variant="outlined"
                                    size="small"
                                    required={true}
                                />
                            </label>
                        </label>
                        <div className={styles.exhSelectContainer}>
                            <Chip label="해설자 목록" sx={{ marginBottom: "0.8rem", lineHeight: "32px" }} />
                            <ExhibitionFormCommentator />
                        </div>
                    </div>
                    <div className={styles.imgContainer}>
                        {create && <img src={fileDataUrl === null ? defaultImage : previewImage ? fileDataUrl : defaultImage} alt={"preview"} />}
                        {edit && <img src={exhibitionRoom.imageUrl !== null ? exhibitionRoom.imageUrl : previewImage !== null ? fileDataUrl : defaultImage} alt={"preview"} />}
                        <input id="file" type={"file"} multiple="multiple" name={"imageUrl"} accept={"image/*"} onChange={onChangeImageFileHandler} style={{ display: "none" }} />
                        <label className={"labelBtn exhibition"} htmlFor={"file"}>{create ? "이미지 등록" : "이미지 변경"}</label>
                        <FormControl sx={{ display: "flex" }}>
                            <Chip label="활성화 여부" sx={{ marginBottom: "0.2rem"}} />
                            <div style={{ display: "inline-block" }}>
                                <span>OFF</span>
                                <Switch
                                    name={"invalid"}
                                    onChange={onChangeSwitch}
                                    sx={{ margin: "0" }}
                                    checked={exhibitionRoom?.invalid === false || exhibitionRoom?.invalid === "false"}
                                />
                                <span>ON</span>
                            </div>
                        </FormControl>
                    </div>
                </Box>
            </Box>
            <ExhibitionFormSubTopic create={create} edit={edit} />
        </form>
    );
};

export default ExhibitionForm;